import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';

const Breadcrumb = ({ customBreadcrumbs }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const routeMap = {
    '/hr-dashboard': { label: 'Dashboard', icon: 'LayoutDashboard' },
    '/candidate-database': { label: 'Candidates', icon: 'Users' },
    '/candidate-profile-detail': { label: 'Profile Detail', icon: 'User' },
    '/cv-upload-processing': { label: 'CV Processing', icon: 'Upload' },
    '/interview-scheduling': { label: 'Interviews', icon: 'Calendar' },
    '/login': { label: 'Login', icon: 'LogIn' }
  };

  const generateBreadcrumbs = () => {
    if (customBreadcrumbs) {
      return customBreadcrumbs;
    }

    const pathSegments = location?.pathname?.split('/')?.filter(Boolean);
    const breadcrumbs = [{ label: 'Home', path: '/hr-dashboard', icon: 'Home' }];

    let currentPath = '';
    pathSegments?.forEach((segment, index) => {
      currentPath += `/${segment}`;
      const route = routeMap?.[currentPath];
      
      if (route) {
        breadcrumbs?.push({
          label: route?.label,
          path: currentPath,
          icon: route?.icon,
          isLast: index === pathSegments?.length - 1
        });
      }
    });

    // Handle query parameters for contextual breadcrumbs
    const searchParams = new URLSearchParams(location.search);
    const status = searchParams?.get('status');
    const filter = searchParams?.get('filter');
    const view = searchParams?.get('view');

    if (status || filter || view) {
      let contextLabel = '';
      if (status === 'active') contextLabel = 'Active Applications';
      else if (status === 'pending') contextLabel = 'Pending Review';
      else if (status === 'interview-ready') contextLabel = 'Interview Ready';
      else if (filter === 'top-matches') contextLabel = 'Top Matches';
      else if (view === 'queue') contextLabel = 'Processing Queue';
      else if (view === 'completed') contextLabel = 'Completed Analysis';
      else if (view === 'failed') contextLabel = 'Failed Processing';
      else if (view === 'today') contextLabel = 'Today\'s Interviews';
      else if (view === 'upcoming') contextLabel = 'Upcoming';
      else if (view === 'history') contextLabel = 'Interview History';

      if (contextLabel) {
        breadcrumbs?.push({
          label: contextLabel,
          path: location?.pathname + location?.search,
          isLast: true
        });
      }
    }

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  const handleNavigation = (path) => {
    if (path) {
      navigate(path);
    }
  };

  // Don't render breadcrumbs on login page
  if (location?.pathname === '/login') {
    return null;
  }

  return (
    <nav className="flex items-center space-x-2 text-sm text-muted-foreground mb-6" aria-label="Breadcrumb">
      {breadcrumbs?.map((crumb, index) => (
        <React.Fragment key={crumb?.path || index}>
          {index > 0 && (
            <Icon name="ChevronRight" size={14} className="text-muted-foreground/60" />
          )}
          
          {crumb?.isLast ? (
            <span className="flex items-center space-x-1.5 text-foreground font-medium">
              {crumb?.icon && <Icon name={crumb?.icon} size={14} />}
              <span>{crumb?.label}</span>
            </span>
          ) : (
            <button
              onClick={() => handleNavigation(crumb?.path)}
              className="flex items-center space-x-1.5 hover:text-foreground transition-colors micro-feedback"
            >
              {crumb?.icon && <Icon name={crumb?.icon} size={14} />}
              <span>{crumb?.label}</span>
            </button>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumb;